/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { RawContextKey } from '../../../../../../platform/contextkey/common/contextkey.js';

export const NOTEBOOK_VARIABLE_VIEW_ENABLED = new RawContextKey<boolean>('notebookVariableViewEnabled', false);
